import { ENABLE_NEW_RELIC } from '../constants/Defaultvalues';

const NEW_RELIC_SCRIPT_ID = 'newrelic-browser-agent';
const NEW_RELIC_INLINE_SCRIPT_ID = 'newrelic-browser-inline-config';

export function loadNewRelic() {
  console.log('loadNewRelic 1', ENABLE_NEW_RELIC)
  // Load New Relic only when explicitly enabled.
  if (ENABLE_NEW_RELIC !== true) return;
  console.log('loadNewRelic 2', ENABLE_NEW_RELIC)
  if (typeof document === 'undefined') return;
  if (document.getElementById(NEW_RELIC_SCRIPT_ID)) return;
  if (document.getElementById(NEW_RELIC_INLINE_SCRIPT_ID)) return;

  // Paste only the New Relic inline snippet CONTENT here.
  // Do NOT include <script>...</script> tags.
  const NEW_RELIC_INLINE_SNIPPET = `
;window.NREUM||(NREUM={});
NREUM.init={distributed_tracing:{enabled:true},performance:{capture_measures:true},browser_consent_mode:{enabled:false},privacy:{cookies_enabled:true},ajax:{deny_list:["bam.nr-data.net"],capture_payloads:'none'}};
NREUM.loader_config={accountID:"7887425",trustKey:"7887425",agentID:"1103492854",licenseKey:"NRJS-cc27cbb7f746114cd45",applicationID:"1103492854"};
NREUM.info={beacon:"bam.nr-data.net",errorBeacon:"bam.nr-data.net",licenseKey:"NRJS-cc27cbb7f746114cd45",applicationID:"1103492854",sa:1};
`.trim();

  const inlineScript = document.createElement('script');
  inlineScript.id = NEW_RELIC_INLINE_SCRIPT_ID;
  inlineScript.type = 'text/javascript';
  inlineScript.innerHTML = NEW_RELIC_INLINE_SNIPPET;
  document.head.appendChild(inlineScript);

  const script = document.createElement('script');
  script.id = NEW_RELIC_SCRIPT_ID;
  script.async = true;
  script.src = 'https://js-agent.newrelic.com/nr-loader-spa-current.min.js';
  document.head.appendChild(script);
}
